import Link from '../components/Link';
import { CONTENT_CLASSES } from '../constants/classNames';
import { ROUTES } from '../constants/config';
import '../styles/ContentPage.css';

export default function NotFoundPage() {
  return (
    <article className={CONTENT_CLASSES.root}>
      <header className={CONTENT_CLASSES.hero}>
        <h1 className={CONTENT_CLASSES.heading}>Oops! This page fizzled out</h1>
        <p className={CONTENT_CLASSES.lead}>We couldn't find that page. Maybe it evaporated?</p>
        <div className={CONTENT_CLASSES.buttonRow}>
          <Link to={ROUTES.LAB} className={CONTENT_CLASSES.button}>
            Back to the lab 🧪
          </Link>
          <Link to={ROUTES.ELEMENTS} className={CONTENT_CLASSES.button}>
            Browse the elements
          </Link>
        </div>
      </header>
    </article>
  );
}
